import 'lazysizes';
import {ready} from '../main/utils';

ready(() => {
  if ('objectFit' in document.documentElement.style === false) {
    Array.from(
      document.querySelectorAll('.partnerships--banner-bg img')
    ).forEach(img => {
      let src = img.srcset || img.src || img.dataset.src || '';
      src = src.split(',').map(v => v.trim());
      src = src[src.length - 1].split(' ')[0];

      img.style.opacity = 0;
      img.parentElement.style.background = `url(${src}) 50% 50% no-repeat`;
      img.parentElement.style.backgroundSize = 'cover';
    });
  }
});
